/**
 * @generated SignedSource<<70ca56ec1f74e30dc2b3d532a56093fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesSidePanel_allowedTabs_viewer$data = {
  readonly account: {
    readonly allowAiFeatures: boolean;
    readonly billingAccount: {
      readonly hasAccessToHubspotFeature: boolean;
      readonly hasAccessToSalesforceFeature: boolean;
    };
    readonly emailDomainList: ReadonlyArray<string>;
    readonly integrations: {
      readonly hubspot: {
        readonly userConnected: boolean;
      } | null;
    };
  };
  readonly integrations: {
    readonly hubspot: {
      readonly isConnected: boolean;
    } | null;
    readonly salesforce: {
      readonly enhancedNotesEnabled: boolean;
      readonly isConnected: boolean;
    } | null;
  };
  readonly " $fragmentType": "SeriesSidePanel_allowedTabs_viewer";
};
export type SeriesSidePanel_allowedTabs_viewer$key = {
  readonly " $data"?: SeriesSidePanel_allowedTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesSidePanel_allowedTabs_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesSidePanel_allowedTabs_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "HubspotUserNode",
          "kind": "LinkedField",
          "name": "hubspot",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesforceUserNode",
          "kind": "LinkedField",
          "name": "salesforce",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enhancedNotesEnabled",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailDomainList",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountIntegrations",
          "kind": "LinkedField",
          "name": "integrations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "HubspotAccountNode",
              "kind": "LinkedField",
              "name": "hubspot",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userConnected",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAiFeatures",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToHubspotFeature",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "hubspot_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"hubspot_integration\")"
            },
            {
              "alias": "hasAccessToSalesforceFeature",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "salesforce_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"salesforce_integration\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "81bbca4a4a2951db1d01d9ca73971abb";

export default node;
